import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import {
  QConfigDuplicationSchema,
  type QConfigDuplicationFormInput,
} from './qconfig-duplication-form-schema';

interface QConfigDuplicationFormProviderProps extends PropsWithChildren {
  oldQConfigName: string;
}

export default function QConfigDuplicationFormProvider(
  props: Readonly<QConfigDuplicationFormProviderProps>,
) {
  const { children, oldQConfigName } = props;

  const defaultValues = useMemo(() => {
    return `Copy of ${oldQConfigName}`;
  }, [oldQConfigName]);

  const formContext = useForm<QConfigDuplicationFormInput>({
    defaultValues: {
      qConfigName: defaultValues,
    },
    resolver: zodResolver(QConfigDuplicationSchema),
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
